import axiosInstance from "../app/axios";
import ProviderServiceDTO from "../shared/dtos/providerServiceDTO";

export const getServicesByProviderId = async (providerId: number) => {
  const result = await axiosInstance.get(`/provider-service/${providerId}`);
  return result.data;
};

export const associateServiceToProvider = async (
  providerServiceDTO: ProviderServiceDTO,
) => {
  const result = await axiosInstance.post(
    "provider-service",
    providerServiceDTO,
  );
  return result.data;
};

export const updateProviderService = async (
  providerServiceDTO: ProviderServiceDTO,
) => {
  const result = await axiosInstance.put(
    "provider-service",
    providerServiceDTO,
  );
  return result.data;
};
